/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SddcSummary { 
    /**
     * Number of total SDDCs across all the scanned orgs, irrespecitive of SDDC state
     */
    num_sddcs: number;
    /**
     * SDDC count by Region
     */
    sddcs_by_region: { [key: string]: number; };
    /**
     * SDDC count by state
     */
    sddcs_by_state: { [key: string]: number; };
}

